export const Quality = {
  Q4096: 'Q4096',
  Q3072: 'Q3072',
  Q2048: 'Q2048',
  Q1536: 'Q1536',
  Q1024: 'Q1024',
  Q768: 'Q768',
} as const;
export type Quality = (typeof Quality)[keyof typeof Quality];

export const AbsoluteQuality = {
  W4000: 'W4000',
  W3200: 'W3200',
  W2400: 'W2400',
  W2000: 'W2000',
  W1600: 'W1600',
  W1200: 'W1200',
  W1000: 'W1000',
  W800: 'W800',
  W600: 'W600',
  W400: 'W400',
  W200: 'W200',
  W100: 'W100',
  W50: 'W50',
} as const;
export type AbsoluteQuality = (typeof AbsoluteQuality)[keyof typeof AbsoluteQuality];

export const QUALITIES = [
  {
    fraction: 3 / 16,
    quality: Quality.Q768,
  },
  {
    fraction: 1 / 4,
    quality: Quality.Q1024,
  },
  {
    fraction: 3 / 8,
    quality: Quality.Q1536,
  },
  {
    fraction: 1 / 2,
    quality: Quality.Q2048,
  },
  {
    fraction: 3 / 4,
    quality: Quality.Q3072,
  },
  {
    fraction: 1,
    quality: Quality.Q4096,
  },
]

export const ABSOLUTE_QUALITIES = [
  {
    width: 50,
    quality: AbsoluteQuality.W50,
  },
  {
    width: 100,
    quality: AbsoluteQuality.W100,
  },
  {
    width: 200,
    quality: AbsoluteQuality.W200,
  },
  {
    width: 400,
    quality: AbsoluteQuality.W400,
  },
  {
    width: 600,
    quality: AbsoluteQuality.W600,
  },
  {
    width: 800,
    quality: AbsoluteQuality.W800,
  },
  {
    width: 1000,
    quality: AbsoluteQuality.W1000,
  },
  {
    width: 1200,
    quality: AbsoluteQuality.W1200,
  },
  {
    width: 1600,
    quality: AbsoluteQuality.W1600,
  },
  {
    width: 2000,
    quality: AbsoluteQuality.W2000,
  },
  {
    width: 2400,
    quality: AbsoluteQuality.W2400,
  },
  {
    width: 3200,
    quality: AbsoluteQuality.W3200,
  },
  {
    width: 4000,
    quality: AbsoluteQuality.W4000,
  },
]
